
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify';
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
import { useThemeMode } from '../../../../_metronic/partials';

export function EditSpaceBgDropdown({ isOpen, setMenuOpen, formik, setSpaceBG, showDeleteModal, setDeleteShowModal, dataRoomId, handleOpenFileUpload }: { isOpen: boolean, setMenuOpen: any, formik: any, setSpaceBG: any, showDeleteModal?: any, setDeleteShowModal?: any, dataRoomId: string | undefined, handleOpenFileUpload: any }) {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()
  // const [showFileUpload, setShowFileUpload] = useState(false);
  // const [modelStatus, setModelStatus] = useState<boolean>(false)


  // const handleOpenFileUpload = () => {
  //   setMenuOpen(false)
  //   setShowFileUpload(true);
  //   setModelStatus(true)
  // };

  // const handleClose = () => {
  //   setModelStatus(false)
  // }

  const handleRemoveBackgroundImage = () => {
    setMenuOpen(false)
    formik.setFieldValue('bannerId', null);
    setSpaceBG('');
    setDeleteShowModal(false)
    toast.success(formatMessage({ id: 'Background Image Removed Successfully' }))
  }

  return (
    <>
      {isOpen && (
        <div className='menu menu-sub menu-sub-dropdown edit-space-bg-dropdown show'>
          {formik.values.bannerId ? (
            <>
              <div className={`option-padding${mode === 'dark' ? '-dark' : ''}`} onClick={handleOpenFileUpload}>
                <p className='mb-0 text-dark font-size-12'>{formatMessage({ id: 'Change Background Image' })}</p>
              </div>
              <div className='separator border-gray-200'></div>
              <div className={`option-padding${mode === 'dark' ? '-dark' : ''}`} onClick={() => setDeleteShowModal(true)}>
                <p className='mb-0 text-danger font-size-12'>{formatMessage({ id: 'Remove Background Image' })}</p>
              </div>
            </>
          ) : (
            <div className={`option-padding${mode === 'dark' ? '-dark' : ''}`} onClick={handleOpenFileUpload}>
              <p className='mb-0 font-size-12'>{formatMessage({ id: 'Add Background Image' })}</p>
            </div>
          )}
        </div>
      )}

      {/* {showFileUpload && (
        <FileUpload
          fileSize={2097152}
          maxFileNumber={1}
          allowType={['image/*', '.jpg', '.jpeg', '.png']}
          metaData={{ module: 'logo', isProtected: false }}
          modalStatus={modelStatus}
          handleClose={handleClose}
          handleSuccess={(id: number, name: string) => {
            setSpaceBG(name)
            formik.setFieldValue('bannerId', id);
            setShowFileUpload(false);
          }}
          showCompatibilityMsg={false}
          resourceType='all'
        />
      )} */}

      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={formatMessage({ id: 'Remove Image' })}
        description={formatMessage({ id: 'Are you sure you want to remove this  Background Image?' })}
        handleDelete={handleRemoveBackgroundImage}
      />
    </>
  )
}

